import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import { useDispatch } from "react-redux";
import LogsTable from "./LogsTable";
import FullPageLoader from "components/common/FullPageLoader";
import { fetchInterpreterAppointmentView } from "slices/interpreter/appointmentSlice";
import { fetchInterpreterAppointmentLogs } from "slices/interpreter/appointmentSlice";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import toast from "react-hot-toast";
import { CheckinCheckoutAdjustmentModal } from "components/appointment/checkinCheckoutAdjustment";
import CouldNotCover from "components/appointment/CouldNotCover";
import DonotCover from "components/appointment/DonotCover";
import CancelModal from "components/appointment/CancelModal";
import { setActionAssign } from "slices/actionButtonSlice";
import ViewTable from "views/appointment/view/ViewTable";
import { setInterpreterIframeUrl } from "../../../slices/interpreter/interpreterIframeSlice";
import Api from "services/api";
import RecordingModal from "views/JoinRoomCall/RecordingModal";
import { Video } from "lucide-react";

const AppointmentView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [item, setItem] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [logs, setLogs] = React.useState([]);
  const [cancelModal, setCancelModal] = React.useState(false);
  const [donotCover, setDonotCover] = React.useState(false);
  const [couldNotCover, setCouldNotCover] = React.useState(false);
  const [checkinCheckoutModal, setCheckinCheckoutModal] = React.useState(false);
  const [recordingUrl, setRecordingUrl] = React.useState(null);
  const [showModal, setShowModal] = React.useState(false);
  const [completingLoading, setCompletingLoading] = React.useState(false);
  const [declineModal, setDeclineModal] = React.useState(false);
  const [declineReason, setDeclineReason] = React.useState('');
  const [declineLoading, setDeclineLoading] = React.useState(false);
  const [inviteActionLoading, setInviteActionLoading] = React.useState(false);

  const callViewApi = async () => {
    const callBack = (success, message, data) => {
      setLoading(false);
      if (success) {
        setItem(data);
        console.log(data);
      } else {
        console.log(message);
      }
    };

    dispatch(fetchInterpreterAppointmentView(id, callBack));
  };

  const fetchLogs = async () => {
    const callBack = (success, message, data) => {
      if (success) {
        setLogs(data);
        console.log(data);
      } else {
        console.log(message);
      }
      // setLogs()
    };
    dispatch(fetchInterpreterAppointmentLogs(id, callBack));
  };

  React.useEffect(() => {
    setLoading(true);
    callViewApi();
    // fetchLogs();
  }, [id]);
  const handleCancel = () => {
    setCancelModal(true);
  };
  const handleCloseCancel = () => {
    setCancelModal(false);
  };
  const handleDonotCover = () => {
    setDonotCover(true);
  };
  const handleCloseDonotCover = () => {
    setDonotCover(false);
  };
  const handleCouldNotCover = () => {
    setCouldNotCover(true);
  };
  const handleCloseCouldNotCover = () => {
    setCouldNotCover(false);
  };
  const handleOpenCheckinCheckoutModal = () => {
    setCheckinCheckoutModal(true);
  };
  const handleCloseCheckinCheckoutModal = () => {
    setCheckinCheckoutModal(false);
  };
  const handleSubmit = (data, end_point, callBack) => {
    setLoading(true);
    const submitCallback = (success, message) => {
      callBack && callBack();
      if (success) {
        handleCloseCancel();
        handleCloseDonotCover();
        handleCloseCouldNotCover();
        handleCloseCheckinCheckoutModal();
        callViewApi();
        fetchLogs();
        toast.success(message, {
          className: "successToast",
        });
        setLoading(false);
      } else {
        toast.error(message, { className: "errorToast" });
        setLoading(false);
      }
    };
    dispatch(setActionAssign(id, data, end_point, submitCallback));
  };

  const appointmentId = id;

  //   Join Video Call handler for interpreter
  const handleInterpreterJoinVideoCall = async () => {
    try {
      const response = await Api.interpreterjoinVideoCall(appointmentId);
      if (response?.status === 200) {
        const iframeUrl = response?.data?.data?.iframe_url;
        dispatch(setInterpreterIframeUrl(iframeUrl));
        navigate(`join-room-call`);
        // console.log("Joined successfully:", response);
      } else {
       const errorMsg = response?.data?.statusText || response?.data?.message || response?.data?.error;
        console.error("Failed to join:", errorMsg);
        toast.error(errorMsg, { className: "errorToast" });
      }
    } catch (err) {
      console.error("Error joining video call:", err);
    }
  };

  React.useEffect(() => {
    if (item) {
      console.log("Recording:", item?.appointment_details?.recording);
    } else {
      console.log("Recording not available");
    }
  }, [item]);

  const handleAcceptInvite = async () => {
    setInviteActionLoading(true);
    try {
      const response = await Api.interpreterAcceptInvite(appointmentId);
      if (response?.status >= 200 && response?.status < 300) {
        toast.success(response?.data?.message || 'Invite accepted. Appointment assigned to you.', { className: 'successToast' });
        callViewApi();
        fetchLogs();
      } else {
        toast.error(response?.data?.message || 'Could not accept invite.', { className: 'errorToast' });
      }
    } catch {
      toast.error('An error occurred.', { className: 'errorToast' });
    } finally {
      setInviteActionLoading(false);
    }
  };

  const handleDeclineInvite = async () => {
    if (!declineReason.trim()) {
      toast.error('Please provide a reason for declining.', { className: 'errorToast' });
      return;
    }
    setDeclineLoading(true);
    try {
      const response = await Api.interpreterDeclineInvite(appointmentId, declineReason);
      if (response?.status >= 200 && response?.status < 300) {
        toast.success('Invite declined.', { className: 'successToast' });
        setDeclineModal(false);
        setDeclineReason('');
        navigate('/interpreter/dashboard');
      } else {
        const msg = response?.data?.message || response?.data?.error || JSON.stringify(response?.data);
        toast.error(msg || 'Could not decline invite.', { className: 'errorToast' });
      }
    } catch (err) {
      toast.error('An error occurred.', { className: 'errorToast' });
    } finally {
      setDeclineLoading(false);
    }
  };

  const handleInterpreterMarkCompleted = async () => {
    setCompletingLoading(true);
    try {
      const response = await Api.interpreterMarkCompleted(appointmentId);
      if (response?.status >= 200 && response?.status < 300) {
        toast.success(response?.data?.message || 'Appointment marked as completed.', { className: 'successToast' });
        callViewApi();
        fetchLogs();
      } else {
        toast.error(response?.data?.message || 'Could not mark as completed.', { className: 'errorToast' });
      }
    } catch {
      toast.error('An error occurred.', { className: 'errorToast' });
    } finally {
      setCompletingLoading(false);
    }
  };

  const showRecordingPopup = () => {
    if (item?.appointment_details?.recording) {
      setRecordingUrl(item?.appointment_details?.recording);
      setShowModal(true);
    } else {
      toast.error("Recording not available for this appointment.", {
        className: "errorToast",
      });
    }
  };

  return (
    <div className="content" style={{}}>
      {loading && <FullPageLoader />}
      <div className="card_table view_table_custom">
        <div className="row_main_head">
          <h2 className={`main_heading`}>View Appointment </h2>
          <div className="text-transform-capitalize main_heading">
            Status : {item?.status}
          </div>
        </div>

        <div className="row_table_head">
          <div className="result-foot">
            <span>Appointment ID : {item?.appid}</span>
          </div>
        </div>

        <div className="row-primary flex-wrap justify-content-between">
          <div className="row-primary flex-wrap">
            {/* Invited — show Accept / Decline, hide Cancel */}
            {item?.my_invite?.status === 'pending' ? (
              <>
                <SubmitButton
                  buttonType="button"
                  className="green"
                  btnText="Accept Invite"
                  loader={inviteActionLoading}
                  handleSubmit={handleAcceptInvite}
                />
                <SubmitButton
                  buttonType="button"
                  className="tomatoRed"
                  btnText="Decline Invite"
                  handleSubmit={() => setDeclineModal(true)}
                />
              </>
            ) : (
              /* Assigned to this interpreter — show Cancel */
              item?.status !== "completed" && item?.interpreter_id && (
                <SubmitButton
                  buttonType="button"
                  className={"tomatoRed"}
                  btnText="Cancel"
                  handleSubmit={handleCancel}
                />
              )
            )}
          </div>

          {/* Join Video Call & View Recording Buttons  */}
          <div className="row-primary flex-wrap">
            {item?.appointment_details?.recording && (
              <SubmitButton
                className="Cancle_button"
                btnText="View Recording"
                handleSubmit={showRecordingPopup}
              />
            )}

            {item?.status !== 'completed' &&
              item?.appointment_assign?.interpreter_joined_at &&
              item?.appointment_assign?.interpreter_left_at && (
              <SubmitButton
                buttonType="button"
                className="green"
                btnText="Mark as Completed"
                loader={completingLoading}
                handleSubmit={handleInterpreterMarkCompleted}
              />
            )}

            {/* Join Video Call only when assigned (not just invited) */}
            {item.type === "VRI" &&
              item?.status !== "completed" &&
              item?.my_invite?.status !== 'pending' &&
              item?.interpreter_id && (
              <SubmitButton
                className="green"
                btnText="Join Video Call"
                icon={<Video />}
                handleSubmit={handleInterpreterJoinVideoCall}
              />
            )}
          </div>
        </div>

        {/* Decline Invite Modal */}
        {declineModal && (
          <div style={{
            position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
            background: 'rgba(0,0,0,0.4)', zIndex: 9999,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <div style={{
              background: '#fff', borderRadius: 12, padding: 32,
              width: 440, boxShadow: '0 4px 24px rgba(0,0,0,0.15)',
            }}>
              <h3 style={{ marginBottom: 16 }}>Decline Invite</h3>
              <p style={{ marginBottom: 12, color: '#555' }}>Please provide a reason for declining this appointment.</p>
              <textarea
                value={declineReason}
                onChange={e => setDeclineReason(e.target.value)}
                placeholder="Enter reason..."
                rows={4}
                style={{
                  width: '100%', padding: '10px 12px', borderRadius: 6,
                  border: '1px solid #ccc', fontSize: 14, resize: 'vertical', boxSizing: 'border-box',
                }}
              />
              <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 20 }}>
                <button
                  onClick={() => { setDeclineModal(false); setDeclineReason(''); }}
                  style={{ padding: '8px 20px', borderRadius: 6, border: '1px solid #ccc', background: '#fff', cursor: 'pointer' }}
                >
                  Cancel
                </button>
                <SubmitButton
                  buttonType="button"
                  className="tomatoRed"
                  btnText="Decline"
                  loader={declineLoading}
                  handleSubmit={handleDeclineInvite}
                />
              </div>
            </div>
          </div>
        )}

        <ViewTable item={item} />
      </div>

      <CancelModal
        isOpen={cancelModal}
        onClose={handleCloseCancel}
        onConfirm={handleSubmit}
        appointmentId={id}
        item={item}
        loader={loading}
      />
      <DonotCover
        isOpen={donotCover}
        onClose={handleCloseDonotCover}
        onConfirm={handleSubmit}
        appointmentId={id}
        item={item}
        loader={loading}
      />
      <CouldNotCover
        isOpen={couldNotCover}
        onClose={handleCloseCouldNotCover}
        onConfirm={handleSubmit}
        appointmentId={id}
        item={item}
        loader={loading}
      />
      <CheckinCheckoutAdjustmentModal
        isOpen={checkinCheckoutModal}
        handleClose={handleCloseCheckinCheckoutModal}
        onConfirm={handleSubmit}
        appointmentId={id}
        onSubmit={handleSubmit}
        item={item}
        loader={loading}
      />
      <RecordingModal
        recordingUrl={recordingUrl}
        showModal={showModal}
        onClose={() => setShowModal(false)}
      />
    </div>
  );
};

export default AppointmentView;
